"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_source-search.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SOURCE_TYPES = [{
  label: 'PROJECTS',
  value: 'PROJECT',
  prefix: 'folder'
}, {
  label: 'VIDEOS',
  value: 'VIDEO',
  prefix: 'video'
}];
var SOURCE_TO_TAG_MAP = {
  PROJECT: {
    id: 'videoProjectId',
    displayName: 'name',
    type: 'PROJECT',
    prefix: 'folder'
  },
  VIDEO: {
    id: 'videoId',
    displayName: 'name',
    type: 'VIDEO',
    prefix: 'video'
  }
};

var SourceSearch = /*#__PURE__*/function (_Component) {
  _inherits(SourceSearch, _Component);

  var _super = _createSuper(SourceSearch);

  function SourceSearch() {
    var _this;

    _classCallCheck(this, SourceSearch);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onSelectSourceType", function (sourceType) {
      _this.setState({
        selectedType: sourceType
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getVideoProjects", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var searchQuery, _this$props, getVideoProjectsByName, organisationId, _yield$getVideoProjec, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              searchQuery = _this.state.searchQuery;
              _this$props = _this.props, getVideoProjectsByName = _this$props.getVideoProjectsByName, organisationId = _this$props.organisationId;
              _context.next = 4;
              return getVideoProjectsByName({
                organisationId: organisationId,
                name: searchQuery
              });

            case 4:
              _yield$getVideoProjec = _context.sent;
              data = _yield$getVideoProjec.data;
              error = _yield$getVideoProjec.error;

              if (!(!data || !data.getVideoProjectsByName || error)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", {
                error: true
              });

            case 9:
              return _context.abrupt("return", {
                results: data.getVideoProjectsByName
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "getVideos", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var searchQuery, _this$props2, getVideosByName, organisationId, _yield$getVideosByNam, data, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              searchQuery = _this.state.searchQuery;
              _this$props2 = _this.props, getVideosByName = _this$props2.getVideosByName, organisationId = _this$props2.organisationId;
              _context2.next = 4;
              return getVideosByName({
                organisationId: organisationId,
                name: searchQuery
              });

            case 4:
              _yield$getVideosByNam = _context2.sent;
              data = _yield$getVideosByNam.data;
              error = _yield$getVideosByNam.error;

              if (!(!data || !data.getVideosByName || error)) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", {
                error: true
              });

            case 9:
              return _context2.abrupt("return", {
                results: data.getVideosByName
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "setResourcesLoading", function () {
      setTimeout(function () {
        var searchResults = _this.state.searchResults;

        if (searchResults) {
          return;
        }

        _this.setState({
          loadingResources: true
        });
      }, 300);
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var selectedType, searchAction, _yield$searchAction, results, error;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              selectedType = _this.state.selectedType;
              searchAction = selectedType.value === 'PROJECT' ? _this.getVideoProjects : _this.getVideos;

              _this.setResourcesLoading();

              _this.setState({
                resultsVisible: true
              });

              _context3.next = 6;
              return searchAction();

            case 6:
              _yield$searchAction = _context3.sent;
              results = _yield$searchAction.results;
              error = _yield$searchAction.error;

              if (!(!results || error)) {
                _context3.next = 11;
                break;
              }

              return _context3.abrupt("return", void _this.setState({
                loadingResources: false
              }));

            case 11:
              _this.setState({
                searchResults: results,
                loadingResources: false
              }, function () {
                var resultsEl = document.querySelector('.source-search__results');

                if (!resultsEl) {
                  return;
                }

                resultsEl.focus();
              });

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "onChangeSearch", function (_ref4) {
      var value = _ref4.target.value;

      _this.setState({
        searchQuery: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectResource", function (result) {
      return function () {
        var selectedType = _this.state.selectedType;
        var onSelectSource = _this.props.onSelectSource;
        var TAG_MAP = SOURCE_TO_TAG_MAP[selectedType.value];
        onSelectSource({
          type: TAG_MAP.type,
          displayName: result[TAG_MAP.displayName],
          id: result[TAG_MAP.id],
          assetIds: result.assetIds
        });

        _this.setState({
          resultsVisible: false,
          searchQuery: '',
          searchResults: void 0
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (_ref5) {
      var keyCode = _ref5.keyCode;

      if (keyCode !== 13) {
        return;
      }

      _this.onSearch();
    });

    _defineProperty(_assertThisInitialized(_this), "onMenuKeyDown", function (_ref6) {
      var keyCode = _ref6.keyCode;

      if (keyCode !== 27) {
        return;
      }

      _this.onHideResults();
    });

    _defineProperty(_assertThisInitialized(_this), "onHideResults", function () {
      _this.setState({
        resultsVisible: false,
        searchResults: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMenuBlur", function (e) {
      var currentTarget = e.currentTarget; // https://stackoverflow.com/questions/11592966/get-the-newly-focussed-element-if-any-from-the-onblur-event/11592974#11592974

      setTimeout(function () {
        if (currentTarget.contains(document.activeElement)) {
          return;
        }

        _this.onHideResults();
      }, 0);
    });

    _this.state = {
      searchQuery: '',
      selectedType: SOURCE_TYPES[0],
      loadingResources: false,
      resultsVisible: false
    };
    return _this;
  }

  _createClass(SourceSearch, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          loadingResources = _this$state.loadingResources,
          searchResults = _this$state.searchResults,
          resultsVisible = _this$state.resultsVisible,
          selectedType = _this$state.selectedType,
          searchQuery = _this$state.searchQuery;
      var TAG_MAP = SOURCE_TO_TAG_MAP[selectedType.value];
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "source-search"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "source-search__inner"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Dropdown, {
          type: "BASIC",
          options: SOURCE_TYPES,
          defaultValue: selectedType,
          onChange: this.onSelectSourceType,
          prefixSize: 15
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "source-search__inner__divider"
        }), /*#__PURE__*/_react.default.createElement("input", {
          onKeyDown: this.onKeyDown,
          onChange: this.onChangeSearch,
          placeholder: "Search",
          value: searchQuery
        })), /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          className: "source-search__search-btn",
          onClick: this.onSearch
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "search",
          color: "white",
          size: 20
        })), resultsVisible ? /*#__PURE__*/_react.default.createElement("div", {
          className: "source-search__results",
          onKeyDown: this.onMenuKeyDown,
          role: "menu",
          tabIndex: 0,
          onBlur: this.onMenuBlur
        }, loadingResources ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          className: "source-search__results__loading",
          name: "shootstagrad",
          spin: true
        }) : null, searchResults && !searchResults.length && !loadingResources ? /*#__PURE__*/_react.default.createElement("p", {
          className: "source-search__results__empty"
        }, "Nothing matches your search. Try something else.") : null, searchResults && searchResults.length && !loadingResources ? searchResults.map(function (result) {
          return (/*#__PURE__*/_react.default.createElement("button", {
              key: result[TAG_MAP.id],
              type: "button",
              className: "source-search__results__result" // We use mouse down so the function is called before the parent onBlur
              ,
              onMouseDown: _this2.onSelectResource(result)
            }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
              name: SOURCE_TO_TAG_MAP[selectedType.value].prefix,
              size: 15,
              color: "michael"
            }), /*#__PURE__*/_react.default.createElement("span", null, result.name))
          );
        }) : null) : null)
      );
    }
  }]);

  return SourceSearch;
}(_react.Component);

exports.default = SourceSearch;